import { colors, fonts } from '../lib/styles';

export const GridBackground = () => (
  <>
    <div style={{
      position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none',
      background: `linear-gradient(rgba(0,255,200,0.03) 1px, transparent 1px),
                   linear-gradient(90deg, rgba(0,255,200,0.03) 1px, transparent 1px)`,
      backgroundSize: '60px 60px',
      maskImage: 'radial-gradient(ellipse at center, black 30%, transparent 80%)',
    }} />
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1, pointerEvents: 'none',
      background: 'repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(0,0,0,0.03) 2px,rgba(0,0,0,0.03) 4px)',
    }} />
  </>
);

export const NeonBadge = ({ children, color = colors.cyan }) => (
  <span style={{
    fontSize: '10px', fontFamily: fonts.mono, fontWeight: 700,
    letterSpacing: '0.12em', textTransform: 'uppercase',
    color, border: `1px solid ${color}`, padding: '2px 8px', borderRadius: '2px',
    boxShadow: `0 0 6px ${color}40`, background: `${color}10`,
    whiteSpace: 'nowrap',
  }}>{children}</span>
);

export const CategoryPill = ({ label, active, onClick }) => (
  <button onClick={onClick} style={{
    fontFamily: fonts.mono, fontSize: '11px', fontWeight: 700,
    letterSpacing: '0.1em', textTransform: 'uppercase',
    padding: '6px 14px', borderRadius: '2px', cursor: 'pointer',
    background: active ? colors.cyan : 'transparent',
    color: active ? '#000' : colors.cyan,
    border: `1px solid ${active ? colors.cyan : colors.cyanDim}`,
    boxShadow: active ? `0 0 12px ${colors.cyanGlow}` : 'none',
    transition: 'all 0.2s ease',
  }}>{label}</button>
);

export const Modal = ({ onClose, children, maxWidth = '680px' }) => (
  <div onClick={onClose} style={{
    position: 'fixed', inset: 0, zIndex: 100,
    background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(6px)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
    overflowY: 'auto',
  }}>
    <div onClick={e => e.stopPropagation()} style={{
      background: '#050d10', border: '1px solid #00ffc830',
      borderRadius: '6px', width: '100%', maxWidth,
      maxHeight: '90vh', overflowY: 'auto',
      boxShadow: '0 0 60px rgba(0,255,200,0.1)',
      animation: 'fadeIn 0.2s ease',
    }}>
      {children}
    </div>
  </div>
);

export const Spinner = ({ size = 20, color = colors.cyan }) => (
  <div style={{
    width: size, height: size, borderRadius: '50%',
    border: `2px solid ${color}30`,
    borderTop: `2px solid ${color}`,
    animation: 'spin 0.8s linear infinite',
    display: 'inline-block',
  }} />
);

export const Divider = () => (
  <div style={{ height: '1px', background: colors.border, margin: '20px 0' }} />
);

export const Logo = ({ size = 'md' }) => {
  const big = size === 'lg';
  return (
    <div>
      <div style={{
        fontFamily: fonts.display,
        fontSize: big ? '28px' : '20px',
        fontWeight: 900,
        letterSpacing: '0.12em',
        color: colors.cyan,
        textShadow: `0 0 20px ${colors.cyanGlow}, 0 0 40px ${colors.cyanDim}`,
        animation: 'flicker 8s infinite',
        lineHeight: 1,
      }}>
        FERRUM<span style={{ color: colors.red }}>_</span>SHIFT
      </div>
      {big && (
        <div style={{
          fontSize: '10px', color: '#ffffff25',
          letterSpacing: '0.2em', marginTop: '4px',
          fontFamily: fonts.mono,
        }}>THE FUTURE OF WORK IS NOW</div>
      )}
    </div>
  );
};
